<div class="betting-limit">
	<div class="betting-limit-description">
		{{ "betting-limit.mandatory-update_description" | jurisdiction | translate }}
	</div>
	<form [formGroup]="bettingLimitForm">
		<div class="betting-limit-form">
			<strong class="betting-limit-form-hint">{{
				"betting-limit.edit-your-limit" | jurisdiction | translate
			}}</strong>
			<mat-radio-group formControlName="limitType" class="betting-limit-form-radio-group">
				<mat-radio-button
					class="betting-limit-form-radio-group-button"
					test-id="betting-limit-wagering-limit"
					[value]="bettingLimitType.wageringLimit"
					>{{ "betting-limit.max-cash" | jurisdiction | translate }}</mat-radio-button
				>
				<mat-radio-button
					class="betting-limit-form-radio-group-button"
					test-id="betting-limit-bet-size-limit"
					[value]="bettingLimitType.betSizeLimit"
					>{{ "betting-limit.bet-size-limit" | jurisdiction | translate }}</mat-radio-button
				>
			</mat-radio-group>

			<mat-form-field class="betting-limit-form-input">
				<input
					matInput
					type="tel"
					[placeholder]="
						'betting-limit.limit-' + bettingLimitForm.value.limitType
							| jurisdiction
							| translate: { currency: currency?.code }
					"
					formControlName="limit"
					obgNumericNotZero
					test-id="betting-limit-input"
				/>
			</mat-form-field>
		</div>
		<div class="betting-limit-action">
			<button
				mat-flat-button
				color="accent"
				[disabled]="!bettingLimitForm.valid"
				(click)="submitBettingLimit()"
				test-id="betting-limit-save-btn"
			>
				{{ "betting-limit.mandatory-update_cta-text" | jurisdiction | translate }}
			</button>
		</div>
	</form>
</div>
